import { initTopbarAccountMenus } from './components/topbar-account-menu.js';
import { initAddCardModal } from './members/add-card-modal.js';
import { initColorModePrompt } from './members/color-mode-prompt.js';
import { initZmanimModal } from './members/zmanim-modal.js';
import { isSessionIdleOverlayVisible } from './session-idle-overlay.js';
import {
    initGuestIdleAttentionPulse,
    suspendGuestIdleAttentionPulse,
    resumeGuestIdleAttentionPulse,
} from './shared/guest-attention-pulse.js';
import { isAssurBemlacha, checkCurrentShabbosMode, zmanimOptions } from './shared/zmanim-shabbos.js';
import { isVoiceCallActive, teardownShabbosPage } from './shabbos-page.js';
import { showShabbosPage, resetIndexHeader } from './members/member-nav.js';
import { openIndexPage } from './members/member-open-index-page.js';
import { showPendingPaymentSharingPrompt } from './shared/payment-sharing-prompt-modal.js';
import { initKioskBatteryIndicator } from './shared/kiosk-battery-indicator.js';

export function initKioskIndexPage(loadCurrentRoute) {
    initTopbarAccountMenus();
    initZmanimModal();
    initAddCardModal();
    showPendingPaymentSharingPrompt();

    const configEl = document.getElementById('kiosk-index-config');
    if (!configEl) {
        throw new Error('kiosk-index-page: missing kiosk-index-config');
    }

    let cfg;
    try {
        cfg = JSON.parse(configEl.textContent);
    } catch {
        throw new Error('kiosk-index-page: invalid kiosk-index-config');
    }

    if (cfg.kioskValidated) {
        initKioskBatteryIndicator();
    } else {
        initColorModePrompt();
    }

    if (typeof cfg.standbyAnimationOn !== 'boolean') {
        throw new Error('kiosk-index-page: standbyAnimationOn must be boolean');
    }

    const guestStandbyAnimationOn = !cfg.userRoleName && cfg.standbyAnimationOn;
    if (guestStandbyAnimationOn) {
        initGuestIdleAttentionPulse();
    }

    let shabbosMode = cfg.shabbosMode;
    let isAssurBemlachaNow = false;
    let userActive = false;
    let lastActivity = Date.now();

    function setAssurBemlachaNow(value) {
        isAssurBemlachaNow = value;
        if (!guestStandbyAnimationOn) {
            return;
        }
        if (value) {
            suspendGuestIdleAttentionPulse();
        } else {
            resumeGuestIdleAttentionPulse();
        }
    }

    const options = zmanimOptions(cfg.congregation);

    function isIdleOverlayBlocking() {
        return isSessionIdleOverlayVisible();
    }

    $(document).on('mousemove keypress input click', function () {
        if (isIdleOverlayBlocking()) return;
        lastActivity = Date.now();
        userActive = true;
    });

    function checkRefresh() {
        if (isIdleOverlayBlocking()) return;
        const activitySpan = Date.now() - lastActivity;
        if (!isAssurBemlachaNow && !isVoiceCallActive() && userActive && activitySpan > cfg.inactivityRefreshMs) {
            window.location.href = window.location.pathname.split('#')[0];
        }
    }

    function endSessionForShabbos() {
        if (cfg.shabbosLogoutUrl) {
            window.location.href = cfg.shabbosLogoutUrl;
            return true;
        }
        return false;
    }

    function checkShabbosIndex() {
        if (isVoiceCallActive()) return;

        let assurBemlacha = false;
        try {
            assurBemlacha = isAssurBemlacha(options);
        } catch (error) {
            console.error(error);
            return;
        }

        const shouldShowShabbos = assurBemlacha || shabbosMode === 1;

        if (isAssurBemlachaNow && shouldShowShabbos) {
            return;
        } else if (!isAssurBemlachaNow && shouldShowShabbos) {
            setAssurBemlachaNow(true);
            if (endSessionForShabbos()) return;
            showShabbosPage(options);
            lastActivity = Date.now();
        } else if (isAssurBemlachaNow && !shouldShowShabbos) {
            setAssurBemlachaNow(false);
            teardownShabbosPage();
            resetIndexHeader();
            openIndexPage();
        }
    }

    function onShabbosPollTick() {
        if (cfg.kioskValidated) {
            checkCurrentShabbosMode(cfg.checkShabbosUrl)
                .then(function (liveMode) { shabbosMode = Number(liveMode) === 1 ? 1 : 0; })
                .catch(function (error) { console.error(error); })
                .finally(checkShabbosIndex);
            return;
        }
        checkShabbosIndex();
    }

    function startShabbosPolling(intervalMs) {
        if (!(intervalMs > 0)) {
            return;
        }

        const workerUrl = cfg.shabbosWorkerUrl;
        if (typeof workerUrl !== 'string' || workerUrl === '') {
            setInterval(onShabbosPollTick, intervalMs);
            return;
        }

        try {
            const shabbosWorker = new Worker(workerUrl);
            shabbosWorker.onmessage = function (e) {
                if (e.data === 'check') {
                    onShabbosPollTick();
                }
            };
            shabbosWorker.onerror = function (error) {
                console.error(error);
                shabbosWorker.terminate();
                setInterval(onShabbosPollTick, intervalMs);
            };
            shabbosWorker.postMessage({ intervalMs: intervalMs });
        } catch (error) {
            console.error(error);
            setInterval(onShabbosPollTick, intervalMs);
        }
    }

    startShabbosPolling(cfg.shabbosCheckIntervalMs);

    function initKioskIndexShabbosState() {
        setInterval(checkRefresh, cfg.inactivityCheckMs);
        window.ck_logged_in = cfg.userRoleName;

        if (!cfg.kioskValidated) {
            loadCurrentRoute();
            return;
        }

        checkCurrentShabbosMode(cfg.checkShabbosUrl)
            .then(function (liveMode) { shabbosMode = Number(liveMode) === 1 ? 1 : 0; })
            .catch(function (error) { console.error(error); })
            .finally(function () {
                if (shabbosMode) {
                    setAssurBemlachaNow(true);
                    if (endSessionForShabbos()) return;
                    resetIndexHeader();
                    showShabbosPage(options);
                    return;
                }

                let initialAssur = false;
                try {
                    initialAssur = isAssurBemlacha(options);
                } catch (error) {
                    console.error(error);
                }
                if (initialAssur) {
                    setAssurBemlachaNow(true);
                    if (endSessionForShabbos()) return;
                    showShabbosPage(options);
                } else {
                    setAssurBemlachaNow(false);
                    loadCurrentRoute();
                }
            });
    }
    initKioskIndexShabbosState();

    $(document).on('keydown', function (e) {
        if ((e.ctrlKey || e.metaKey) && (e.key === 'p' || e.charCode === 16 || e.charCode === 112 || e.keyCode === 80)) {
            alert('This option is not available in the kiosk');
            e.cancelBubble = true;
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    });
}
